import { render } from "./PoliciesList.vue?vue&type=template&id=75970e2d&ts=true"
import script from "./PoliciesList.vue?vue&type=script&lang=ts"
export * from "./PoliciesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Profile/Policies/PoliciesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75970e2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75970e2d', __exports__)) {
    api.reload('75970e2d', __exports__)
  }
  
  module.hot.accept("./PoliciesList.vue?vue&type=template&id=75970e2d&ts=true", () => {
    api.rerender('75970e2d', render)
  })

}


export default __exports__